<template>
  <div class="pa-5" style="height: 100%">
    <div class="d-flex align-center">
      <v-text-field v-model="file" outlined prepend-inner-icon="mdi-file" disabled hide-details></v-text-field>
      <v-btn color="primary" @click="cancelChooseFile" text>Chọn tệp khác</v-btn>
    </div>
    <div v-if="isError">
      <h2 class="pt-4 pb-2 red--text">Lỗi dữ liệu</h2>
      <p class="red--text">Vui lòng kiểm tra dữ liệu của dòng {{ indexError }}</p>
    </div>
    <v-card>
      <v-data-table
        class="mt-4"
        mobile-breakpoint="0"
        :options.sync="options"
        item-key="code"
        :headers="headers"
        :items="impItems"
        sort-by="index"
        :footer-props="{
          'items-per-page-text': 'Hiển thị mỗi trang',
          'items-per-page-all-text': 'Tất cả',
        }"
        disable-sort
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:[`item.code`]="{ item }">
          {{ item.code }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    file: String,
    isError: Boolean,
  },
  data() {
    return {
      options: {},
    }
  },
  methods: {
    ...mapMutations('boardingClassTeacher', ['setImportedItems']),
    cancelChooseFile() {
      this.$emit('reset')
      this.setImportedItems([])
    },
  },
  computed: {
    headers() {
      return [
        { text: 'Tên giáo viên', value: 'name' },
        { text: 'Mã giáo viên', value: 'code' },
      ]
    },
    ...mapState('boardingClassTeacher', ['impItems']),
    indexError() {
      let arr = []
      if (this.isError) {
        for (let item of this.impItems) {
          arr.unshift(item.index)
        }
      }
      return arr.join(', ')
    },
  },
}
</script>
<style scoped>
.previewFile {
  position: absolute;
  top: 2.1%;
  left: 1.5%;
  color: #0d47a1;
}
</style>
